import axios from '@/plugins/axios';
import { parseDecimalInput as parseAmountInput } from '@/utils/numberFormat';
import utils from '@/stores/utils';
import permissions from './submodules/permissions';
import scopes from './submodules/scopes';

const state = {
    group_name: null,
    group_permissions: [],
    group_scope_codes: [],

    group: null,
    group_loading: false,
    group_deleting: false,
    group_saving: false,
    group_saving_errors: {},
};

const mutations = {

    updateGroup(state, group) {
        state.group = group;
        state.group_name = group.name;
        state.group_permissions = group.permissions || [];
        state.group_scope_codes = group.scope_codes || [];
    },

    toggleScope(state, { code, enabled }) {
        const current = new Set(state.group_scope_codes || []);
        if (enabled) {
            current.add(code);
        } else {
            current.delete(code);
        }
        state.group_scope_codes = [...current];
    },

    setModuleScopes(state, { codes, enabled }) {
        const current = new Set(state.group_scope_codes || []);
        (codes || []).forEach((code) => {
            if (enabled) {
                current.add(code);
            } else {
                current.delete(code);
            }
        });
        state.group_scope_codes = [...current];
    },

    updateGroupLoading(state, loading) {
        state.group_loading = loading;
    },

    updateGroupLoadingErrors(state, errors) {
        state.group_loading_errors = errors;
    },

    updateGroupSaving(state, saving) {
        state.group_saving = saving;
    },

    updateGroupDeleting(state, deleting) {
        state.group_deleting = deleting;
    },

    updatePermissions(state, permissions) {
        state.group.permissions = permissions || [];
        state.group_permissions = permissions || [];
    },

    updateGroupSavingErrors(state, errors) {
        state.group_saving_errors = errors;
    },

    updateGroupName(state, name) {
        state.group.name = name;
        state.group_name = name;
        if (state.group_saving_errors?.name) {
            state.group_saving_errors.name = null;
        }
    },

    updatePurchaseApprovalLimitGlobal(state, value) {
        state.group.purchase_approval_limit_global = parseAmountInput(value);
        if (state.group_saving_errors?.purchase_approval_limit_global) {
            state.group_saving_errors.purchase_approval_limit_global = null;
        }
    },

};

const buildGroupPayload = (group, groupScopeCodes) => ({
    id: group?.id,
    name: group?.name,
    owner: group?.owner,
    scope_codes: groupScopeCodes || group?.scope_codes || [],
    purchase_approval_limit_global: group?.purchase_approval_limit_global ?? null,
});

const actions = {
    async init({ commit, dispatch, state }, params) {
        commit('updateGroup', params.group)

        await dispatch('scopes/init', { profile: params.profile });
        await dispatch('scopes/fetchScopes');
    },

    async fetchGroup({ commit, dispatch, state }, params) {
        commit('updateGroupLoadingErrors', null);
        commit('updateGroupLoading', true);

        try {
            const response = await axios.get(`/api/groups/${params.group_id}/`);
            commit('updateGroupLoading', false);
            commit('updateGroup', response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateGroupLoading', false);
            commit('updateGroupLoadingErrors', error.details);
            throw error;
        }
    },

    async saveGroup({ commit, state }) {
        commit('updateGroupSaving', true);

        let url = '/api/groups/';
        let method = axios.post;

        if (state.group.id) {
            url = `/api/groups/${state.group.id}/`;
            method = axios.put;
        }
        try {
            const payload = buildGroupPayload(state.group, state.group_scope_codes);
            const response = await method(url, payload);
            commit('updateGroup', response.data);
            commit('updateGroupSavingErrors', {});
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateGroupSavingErrors', error.details);
            throw error;
        } finally {
            commit('updateGroupSaving', false);
        }
    },

    async deleteGroup({ commit, dispatch, state }, params) {
        commit('updateGroupDeleting', true);

        try {
            const response = await axios.delete(`/api/groups/${params.instance.id}/`);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit('updateGroupDeleting', false);
        }
    },

    async recoverPassword({ commit, dispatch, state }, params) {
        try {
            const response = await axios.post("/api/account/recover/", { email: params.instance.email });
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    }

};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        permissions: permissions(),
        scopes: scopes(),
    }
};




